import { useEffect, FC } from "react"
import { useLocation, useNavigate } from "react-router"
import { FetchStatus } from "@/hooks"
import { useGetMeApi } from "@/hooks/api/account"

import { useStore } from "@/store"
import { transToCurrentUser } from "@/hooks/api/types"
export interface AuthGuardProps {
  children?: React.ReactNode
}

const AuthGuard: FC<AuthGuardProps> = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [setUserMe] = useStore((state) => [state.setUserMe])

  const {
    data: meData,
    error: meError,
    status: meStatus,
    fetchFn: getMeApi,
  } = useGetMeApi()

  useEffect(() => {
    const isLogin = localStorage.getItem("loggedIn")
    if (!isLogin && location.pathname !== "/login") {
      localStorage.setItem("redirectAfterLogin", location.pathname)
      navigate("/login")
      return
    }

    if (meStatus === FetchStatus.Idle) {
      void getMeApi().catch(() => {
        // Auth state is handled by meError below; suppress the duplicate
        // unhandled promise noise for expected auth failures like 401.
      })
    }
  }, [location.pathname, meStatus, navigate, getMeApi])

  useEffect(() => {
    const isLoginPage = location.pathname === "/login"
    const hasLoginError = new URLSearchParams(location.search).has("error_code")

    if (meData && meData.data) {
      console.log("Already logged in.", meData)
      localStorage.setItem("loggedIn", JSON.stringify({ type: "unknown" }))
      setUserMe(transToCurrentUser(meData.data))
      if (isLoginPage && !hasLoginError) {
        navigate("/")
      } else if (location.pathname === "/") {
        const redirectAfterLogin = localStorage.getItem("redirectAfterLogin")
        if (redirectAfterLogin) {
          console.debug(
            "do redirect after login from auth guard",
            redirectAfterLogin
          )
          localStorage.removeItem("redirectAfterLogin")
          navigate(redirectAfterLogin)
        }
      }
    }

    if (meError) {
      console.log("Failed to get account info.", meError)
      localStorage.removeItem("loggedIn")
      setUserMe(null)
      if (!isLoginPage) {
        navigate("/login")
      }
    }
  }, [location.pathname, location.search, meData, meError, navigate, setUserMe])

  return <>{props.children}</>
}

export default AuthGuard
